import $ from 'jquery';
import anime from 'animejs';
import Choices from 'choices.js';
import Utils from '../utils/Utils.js';
import { resizeScroll } from '../core/ScrollService.js';
const initTabsTagsArrows = () => {
    const sections = document.querySelectorAll('.pSection--tabs_tags_arrows');
    if (!sections.length) return;

    sections.forEach((section) => {
        if (section.dataset.tabsInit === '1') return;
        section.dataset.tabsInit = '1';

        const items = Array.from(section.querySelectorAll('.tabs_tags_arrows_item'));
        if (!items.length) return;

        const stack = section.querySelector('.tabs_tags_arrows_stack');
        const navItems = Array.from(section.querySelectorAll('.tabs_tags_arrows_nav_item'));
        const controlUp = section.querySelector('.tabs_tags_arrows_control--up');
        const controlDown = section.querySelector('.tabs_tags_arrows_control--down');

        const total = items.length;
        const indexMap = new Map(items.map((el, i) => [el, i]));
        let currentIndex = 0;
        let isAnimating = false;
        let hasScrolledOnce = false;

        const isMobile = () => window.innerWidth <= 930;
        const slotOf = (i, active) => (i - active + total) % total;

        const COLORS = ['#E94C2C', '#EC6E55', '#EF917F'];

        const setSlotClasses = (item, slot) => {
            item.classList.toggle('is-slot-0', slot === 0);
            item.classList.toggle('is-slot-1', slot === 1);
            item.classList.toggle('is-slot-2', slot === 2);
            item.classList.toggle('is-slot-hidden', slot > 2);
        };

        const waitImages = async () => {
            const imgs = Array.from(section.querySelectorAll('img'));
            if (!imgs.length) return;

            await Promise.all(
                imgs.map((img) => {
                    if (img.complete) return Promise.resolve();
                    return new Promise((resolve) => {
                        img.addEventListener('load', resolve, { once: true });
                        img.addEventListener('error', resolve, { once: true });
                    });
                })
            );
        };

        const imgs = section.querySelectorAll('.tabs_tags_arrows_item_image img');
        imgs.forEach((img) => {
            img.addEventListener('load', () => {
                section.dataset.tabsHeightsEqualized = '';
                equalizeTabHeightsOnce();
            }, { once: true });
        });

        // const measureNaturalHeight = (item) => {
        //     const prev = {
        //         height: item.style.height,
        //         minHeight: item.style.minHeight,
        //         transform: item.style.transform,
        //         opacity: item.style.opacity,
        //         pointerEvents: item.style.pointerEvents,
        //         visibility: item.style.visibility,
        //         position: item.style.position,
        //         top: item.style.top,
        //     };

        //     item.style.height = 'auto';
        //     item.style.minHeight = '0';
        //     item.style.transform = 'none';
        //     item.style.opacity = '1';
        //     item.style.pointerEvents = 'none';
        //     item.style.visibility = 'visible';
        //     item.style.position = 'static';
        //     item.style.top = 'auto';

        //     const rect = item.getBoundingClientRect();
        //     const offsetH = item.offsetHeight;
        //     const scrollH = item.scrollHeight;
            
        //     const h = Math.max(
        //         Math.ceil(rect.height),
        //         Math.ceil(offsetH),
        //         Math.ceil(scrollH)
        //     );

        //     item.style.height = prev.height;
        //     item.style.minHeight = prev.minHeight;
        //     item.style.transform = prev.transform;
        //     item.style.opacity = prev.opacity;
        //     item.style.pointerEvents = prev.pointerEvents;
        //     item.style.visibility = prev.visibility;
        //     item.style.position = prev.position;
        //     item.style.top = prev.top;

        //     return h;
        // };

        const equalizeTabHeightsOnce = async () => {

            await waitImages();
            if (document.fonts && document.fonts.ready) {
                await document.fonts.ready.catch(() => { });
            }

            await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
        };


        const updateContainerHeight = () => {

            const activeItem = items.find((item) => {
                const i = indexMap.get(item);
                return slotOf(i, currentIndex) === 0;
            });

        };


        const applyStateInstant = () => {
            updateContainerHeight(true);
            let maxHeight = 0;
            section.querySelectorAll('.tabs_tags_arrows_item').forEach((item) => {
                const h = item.offsetHeight;
                if (h > maxHeight) maxHeight = h;
            });
            const extraHeight = isMobile() ? 70 : 90;
            if (isMobile()) {
                stack.style.height = `${maxHeight + extraHeight}px`;
                items.forEach((item) => {
                    item.style.height = `${maxHeight + extraHeight}px`;
                });
            } else {
                stack.style.height = `${maxHeight + extraHeight}px`;
                items.forEach((item) => {
                    item.style.height = `${maxHeight}px`;
                });
            }

            setTimeout(() => {
            items.forEach((item, i) => {
                const slot = slotOf(i, currentIndex);
                const mobile = isMobile();

                let y = 0, s = 1, o = 1;
                if (slot === 0) { y = 0; s = 1; o = 1; }
                else if (slot === 1) { y = mobile ? -45 : -45; s = 0.96; o = 1; }
                else if (slot === 2) { y = mobile ? -90 : -90; s = 0.92; o = 1; }
                else { y = -60; s = 0.94; o = 0; }

                item.classList.toggle('active', slot === 0);
                setSlotClasses(item, slot);

                anime.set(item, {
                    translateY: y,
                    scale: s,
                    opacity: o,
                    backgroundColor: COLORS[Math.min(slot, 2)]
                });
            });

            navItems.forEach((btn, idx) => btn.classList.toggle('active', idx === currentIndex));
            if (controlUp) controlUp.disabled = !hasScrolledOnce && (currentIndex === 0);
            if (controlDown) controlDown.disabled = false; 
    }, 200);

        };

        const animateTo = (nextIndex) => {
            if (isAnimating || nextIndex === currentIndex) return;
            isAnimating = true;

            anime.remove(items);

            const DURATION = 500;
            const EASING = 'cubicBezier(0.22, 1, 0.36, 1)';
            const mobile = isMobile();

            anime({
                targets: items,
                translateY: (el) => {
                    const i = indexMap.get(el);
                    const slot = slotOf(i, nextIndex);
                    if (slot === 0) return 0;
                    if (slot === 1) return mobile ? -45 : -45;
                    if (slot === 2) return mobile ? -90 : -90;
                    return -60;
                },
                scale: (el) => {
                    const i = indexMap.get(el);
                    const slot = slotOf(i, nextIndex);
                    if (slot === 0) return 1;
                    if (slot === 1) return 0.96;
                    if (slot === 2) return 0.92;
                    return 0.94;
                },
                opacity: (el) => {
                    const i = indexMap.get(el);
                    const slot = slotOf(i, nextIndex);
                    if (slot <= 2) return 1;
                    return 0;
                },
                backgroundColor: (el) => {
                    const i = indexMap.get(el);
                    const slot = slotOf(i, nextIndex);
                    return COLORS[Math.min(slot, 2)];
                },
                duration: DURATION,
                easing: EASING,
                begin: () => {
                    items.forEach((item) => {
                        const i = indexMap.get(item);
                        setSlotClasses(item, slotOf(i, nextIndex));
                    });
                    navItems.forEach((btn, idx) => btn.classList.toggle('active', idx === nextIndex));
                },
                complete: () => {
                    currentIndex = nextIndex;

                    items.forEach((item) => {
                        const i = indexMap.get(item);
                        item.classList.toggle('active', slotOf(i, currentIndex) === 0);
                    });

                    if (controlUp) controlUp.disabled = false;
                    if (controlDown) controlDown.disabled = false;

                    isAnimating = false;
                    updateContainerHeight();

                    resizeScroll();
                }
            });
        };

        const goToNext = () => {
            hasScrolledOnce = true;
            animateTo((currentIndex + 1) % total);
        };
        const goToPrev = () => {
            hasScrolledOnce = true;
            animateTo((currentIndex - 1 + total) % total);
        };

        if (controlUp) controlUp.addEventListener('click', (e) => { e.preventDefault(); goToPrev(); });
        if (controlDown) controlDown.addEventListener('click', (e) => { e.preventDefault(); goToNext(); });

        navItems.forEach((btn, idx) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                if (isAnimating || idx === currentIndex) return;
                hasScrolledOnce = true;
                animateTo(idx);
            });
        });

        applyStateInstant();
        equalizeTabHeightsOnce();
    });
};


export { initTabsTagsArrows };
